import { render, staticRenderFns } from "./ReferralValidation.vue?vue&type=template&id=9d2a0b96&"
import script from "./ReferralValidation.vue?vue&type=script&lang=js&"
export * from "./ReferralValidation.vue?vue&type=script&lang=js&"
import style0 from "./ReferralValidation.vue?vue&type=style&index=0&id=9d2a0b96&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports